import { CALL_API } from '../middleware/ApiMiddleware';

export const PRODUCTS_FETCH_REQUEST = 'PRODUCTS_FETCH_REQUEST';
export const PRODUCTS_FETCH_SUCCESS = 'PRODUCTS_FETCH_SUCCESS';
export const PRODUCTS_FETCH_FAILURE = 'PRODUCTS_FETCH_FAILURE';

export const PRODUCT_FETCH_REQUEST = 'PRODUCT_FETCH_REQUEST';
export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS';
export const PRODUCT_FETCH_FAILURE = 'PRODUCT_FETCH_FAILURE';

export const PRODUCT_CREATE_REQUEST = 'PRODUCT_CREATE_REQUEST';
export const PRODUCT_CREATE_SUCCESS = 'PRODUCT_CREATE_SUCCESS';
export const PRODUCT_CREATE_FAILURE = 'PRODUCT_CREATE_FAILURE';

export const PRODUCT_UPDATE_REQUEST = 'PRODUCT_UPDATE_REQUEST';
export const PRODUCT_UPDATE_SUCCESS = 'PRODUCT_UPDATE_SUCCESS';
export const PRODUCT_UPDATE_FAILURE = 'PRODUCT_UPDATE_FAILURE';

export const PRODUCT_BULK_MODIFY_REQUEST = 'PRODUCT_BULK_MODIFY_REQUEST';
export const PRODUCT_BULK_MODIFY_SUCCESS = 'PRODUCT_BULK_MODIFY_SUCCESS';
export const PRODUCT_BULK_MODIFY_FAILURE = 'PRODUCT_BULK_MODIFY_FAILURE';

export const fetchAgencyProducts = () => ({
  [CALL_API]: {
    endpoint: 'agencies/config/products/',
    method: 'get',
    authenticated: true,
    types: [PRODUCTS_FETCH_REQUEST, PRODUCTS_FETCH_SUCCESS, PRODUCTS_FETCH_FAILURE],
    hideLoadingWidget: true,
  },
});

// TODO: verify if needed, else remove
export const fetchProducts = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/products/`,
    method: 'get',
    authenticated: true,
    types: [PRODUCTS_FETCH_REQUEST, PRODUCTS_FETCH_SUCCESS, PRODUCTS_FETCH_FAILURE],
  },
});

export const fetchProduct = (agencyId: number, productId: number) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/products/${productId}`,
    method: 'get',
    authenticated: true,
    types: [PRODUCT_FETCH_REQUEST, PRODUCT_FETCH_SUCCESS, PRODUCT_FETCH_FAILURE],
  },
});

export const createProduct = (agencyId: number, product: IProduct) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/products/`,
    method: 'post',
    body: product,
    authenticated: true,
    types: [PRODUCT_CREATE_REQUEST, PRODUCT_CREATE_SUCCESS, PRODUCT_CREATE_FAILURE],
  },
});

export const updateProduct = (agencyId: number, productId: number, product: IProduct) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/products/${productId}`,
    method: 'put',
    body: product,
    authenticated: true,
    types: [PRODUCT_UPDATE_REQUEST, PRODUCT_UPDATE_SUCCESS, PRODUCT_UPDATE_FAILURE],
  },
});

export const productBulkModify = (agencyId: number, products: IBulkModify) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/products/bulkModify`,
    method: 'post',
    body: products,
    authenticated: true,
    types: [PRODUCT_BULK_MODIFY_REQUEST, PRODUCT_BULK_MODIFY_SUCCESS, PRODUCT_BULK_MODIFY_FAILURE],
  },
});
